import { FIRST_MESSAGE } from "@/constants"
import { customFetch } from "@/modules/fetch"
import type { Message, Reaction, ServerMessage } from "@/types"
import { useCallback, useEffect, useState } from "react"
import { v4 as uuidv4 } from "uuid"

function createFirstMessage(): Message {
  return { id: uuidv4(), sender: "bot", date: new Date().toISOString(), text: FIRST_MESSAGE, reaction: null }
}

function getFallbackHistory(currentHistory: Message[] | null): Message[] {
  return currentHistory?.length ? currentHistory : [createFirstMessage()]
}

export function useChatHistory(sessionId: string | null) {
  const [messages, setMessages] = useState<Message[]>([])
  const [loadingHistory, setLoadingHistory] = useState(false)

  const fetchHistory = useCallback(async () => {
    if (!sessionId) return setMessages([createFirstMessage()])

    setLoadingHistory(true)

    try {
      const res = (await customFetch(`/chat?sessionId=${sessionId}`).then<{ messages: ServerMessage[] }>((res) => res.json())).messages

      if (!Array.isArray(res) || !res.length) {
        setMessages([createFirstMessage()])
        return
      }

      setMessages(
        res.map((msg) => ({
          id: msg.id,
          sender: msg.isAnswer ? "bot" : "user",
          text: msg.text,
          date: msg.date,
          reaction: msg.reaction ? (msg.reaction?.toLowerCase() as Reaction) : null,
        }))
      )
    } catch (err) {
      console.error("Ошибка загрузки истории:", err)
      setMessages((prev) => getFallbackHistory(prev))
    } finally {
      setLoadingHistory(false)
    }
  }, [sessionId])

  useEffect(() => {
    fetchHistory()
  }, [fetchHistory])

  return { messages, setMessages, loadingHistory }
}
